import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { EncrDecrService } from '../../services/encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class PartnersService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { }


    getPartnersCategory(){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.get(environment.apiURI + 'partner-category', { headers: headers_object }).toPromise();
    }
    addPartnersCategory(data){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'partner-category', data, { headers: headers_object }).toPromise();
    }

    deletePartnersCategory(partnerCategory){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.delete(environment.apiURI + 'partner-category/'+partnerCategory, { headers: headers_object }).toPromise();
    }

    arrangeCategory(current, desire){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'partner-category/arrange', {current_position: current, desire_position: desire}, { headers: headers_object }).toPromise();
    }

    updatePartnersCategory(partnerCategory,name,description){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.put(environment.apiURI + 'partner-category/'+partnerCategory, {"name": name, "description": description}, { headers: headers_object }).toPromise();
    }

    getPartners(){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.get(environment.apiURI + 'partner', { headers: headers_object }).toPromise();
    }

    addPartner(data){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'partner', data, { headers: headers_object }).toPromise();
    }

    updatePartner(partner,data){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'partner/'+partner, data, { headers: headers_object }).toPromise();
    }

    deletePartner(partner){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.delete(environment.apiURI + 'partner/'+partner, { headers: headers_object }).toPromise();
    }

    arrangePartner(current, desire){
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'partner/arrange', {current_position: current, desire_position: desire}, { headers: headers_object }).toPromise();
    }

    getPartnersUser(){
      return this.http.get(environment.apiURI + 'partners').toPromise();
    }


}
